import React from "react";
import "./body.css";
function Footer() {
    const currentYear = new Date().getFullYear();
    return (
        <section className="footerbody">
            <h3>Copyright Invest With Knowledge! {currentYear}</h3>
        </section>
    );
}

export default Footer;
